const PlayIcon = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <foreignObject x="-20" y="-20" width="88" height="88">
                <div
                    style={{
                        backdropFilter: 'blur(10px)',
                        clipPath: 'url(#bgblur_0_1062_12788_clip_path)',
                        height: '100%',
                        width: '100%',
                    }}
                ></div>
            </foreignObject>
            <g data-figma-bg-blur-radius="20">
                <rect width="48" height="48" rx="24" fill="black" fillOpacity="0.2" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34.5167 22.6568C35.6223 23.2096 35.6223 24.7873 34.5167 25.3401L20.1708 32.513C19.1735 33.0117 18 32.2864 18 31.1714L18 16.8255C18 15.7104 19.1735 14.9852 20.1708 15.4838L34.5167 22.6568Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="bgblur_0_1062_12788_clip_path" transform="translate(20 20)">
                    <rect width="48" height="48" rx="24" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PlayIcon;
